export function removeWhitespace(text) {
    if (typeof text === 'string') {
        return text.replace(/\s/g, '');
    } else {
        return '';
    }
}

export default removeWhitespace;
